import { assert } from "@awayjs/graphics";
import { Scope } from "./run/Scope";
import { HasNext2Info } from "./run/HasNext2Info";
import { validateCall } from "./run/validateCall";
import { validateConstruct } from "./run/validateConstruct";
import { axCoerceString } from "./run/axCoerceString";
import { release } from "@awayfl/swf-loader";
import { Multiname } from "./abc/lazy/Multiname";
import { axCoerceName } from "./run/axCoerceName";
import { isNumeric, jsGlobal } from "@awayfl/swf-loader";
import { b2Class } from "./btd";
export var Bytecode;
(function (Bytecode) {
    Bytecode[Bytecode["BKPT"] = 1] = "BKPT";
    Bytecode[Bytecode["NOP"] = 2] = "NOP";
    Bytecode[Bytecode["THROW"] = 3] = "THROW";
    Bytecode[Bytecode["GETSUPER"] = 4] = "GETSUPER";
    Bytecode[Bytecode["GETSUPER_DYN"] = 260] = "GETSUPER_DYN";
    Bytecode[Bytecode["SETSUPER"] = 5] = "SETSUPER";
    Bytecode[Bytecode["SETSUPER_DYN"] = 261] = "SETSUPER_DYN";
    Bytecode[Bytecode["DXNS"] = 6] = "DXNS";
    Bytecode[Bytecode["DXNSLATE"] = 7] = "DXNSLATE";
    Bytecode[Bytecode["KILL"] = 8] = "KILL";
    Bytecode[Bytecode["LABEL"] = 9] = "LABEL";
    Bytecode[Bytecode["LF32X4"] = 10] = "LF32X4";
    Bytecode[Bytecode["SF32X4"] = 11] = "SF32X4";
    Bytecode[Bytecode["IFNLT"] = 12] = "IFNLT";
    Bytecode[Bytecode["IFNLE"] = 13] = "IFNLE";
    Bytecode[Bytecode["IFNGT"] = 14] = "IFNGT";
    Bytecode[Bytecode["IFNGE"] = 15] = "IFNGE";
    Bytecode[Bytecode["JUMP"] = 16] = "JUMP";
    Bytecode[Bytecode["IFTRUE"] = 17] = "IFTRUE";
    Bytecode[Bytecode["IFFALSE"] = 18] = "IFFALSE";
    Bytecode[Bytecode["IFEQ"] = 19] = "IFEQ";
    Bytecode[Bytecode["IFNE"] = 20] = "IFNE";
    Bytecode[Bytecode["IFLT"] = 21] = "IFLT";
    Bytecode[Bytecode["IFLE"] = 22] = "IFLE";
    Bytecode[Bytecode["IFGT"] = 23] = "IFGT";
    Bytecode[Bytecode["IFGE"] = 24] = "IFGE";
    Bytecode[Bytecode["IFSTRICTEQ"] = 25] = "IFSTRICTEQ";
    Bytecode[Bytecode["IFSTRICTNE"] = 26] = "IFSTRICTNE";
    Bytecode[Bytecode["LOOKUPSWITCH"] = 27] = "LOOKUPSWITCH";
    Bytecode[Bytecode["PUSHWITH"] = 28] = "PUSHWITH";
    Bytecode[Bytecode["POPSCOPE"] = 29] = "POPSCOPE";
    Bytecode[Bytecode["NEXTNAME"] = 30] = "NEXTNAME";
    Bytecode[Bytecode["HASNEXT"] = 31] = "HASNEXT";
    Bytecode[Bytecode["PUSHNULL"] = 32] = "PUSHNULL";
    Bytecode[Bytecode["PUSHUNDEFINED"] = 33] = "PUSHUNDEFINED";
    Bytecode[Bytecode["PUSHFLOAT"] = 34] = "PUSHFLOAT";
    Bytecode[Bytecode["NEXTVALUE"] = 35] = "NEXTVALUE";
    Bytecode[Bytecode["PUSHBYTE"] = 36] = "PUSHBYTE";
    Bytecode[Bytecode["PUSHSHORT"] = 37] = "PUSHSHORT";
    Bytecode[Bytecode["PUSHTRUE"] = 38] = "PUSHTRUE";
    Bytecode[Bytecode["PUSHFALSE"] = 39] = "PUSHFALSE";
    Bytecode[Bytecode["PUSHNAN"] = 40] = "PUSHNAN";
    Bytecode[Bytecode["POP"] = 41] = "POP";
    Bytecode[Bytecode["DUP"] = 42] = "DUP";
    Bytecode[Bytecode["SWAP"] = 43] = "SWAP";
    Bytecode[Bytecode["PUSHSTRING"] = 44] = "PUSHSTRING";
    Bytecode[Bytecode["PUSHINT"] = 45] = "PUSHINT";
    Bytecode[Bytecode["PUSHUINT"] = 46] = "PUSHUINT";
    Bytecode[Bytecode["PUSHDOUBLE"] = 47] = "PUSHDOUBLE";
    Bytecode[Bytecode["PUSHSCOPE"] = 48] = "PUSHSCOPE";
    Bytecode[Bytecode["PUSHNAMESPACE"] = 49] = "PUSHNAMESPACE";
    Bytecode[Bytecode["HASNEXT2"] = 50] = "HASNEXT2";
    Bytecode[Bytecode["LI8"] = 53] = "LI8";
    Bytecode[Bytecode["LI16"] = 54] = "LI16";
    Bytecode[Bytecode["LI32"] = 55] = "LI32";
    Bytecode[Bytecode["LF32"] = 56] = "LF32";
    Bytecode[Bytecode["LF64"] = 57] = "LF64";
    Bytecode[Bytecode["SI8"] = 58] = "SI8";
    Bytecode[Bytecode["SI16"] = 59] = "SI16";
    Bytecode[Bytecode["SI32"] = 60] = "SI32";
    Bytecode[Bytecode["SF32"] = 61] = "SF32";
    Bytecode[Bytecode["SF64"] = 62] = "SF64";
    Bytecode[Bytecode["NEWFUNCTION"] = 64] = "NEWFUNCTION";
    Bytecode[Bytecode["CALL"] = 65] = "CALL";
    Bytecode[Bytecode["CONSTRUCT"] = 66] = "CONSTRUCT";
    Bytecode[Bytecode["CALLMETHOD"] = 67] = "CALLMETHOD";
    Bytecode[Bytecode["CALLSTATIC"] = 68] = "CALLSTATIC";
    Bytecode[Bytecode["CALLSUPER"] = 69] = "CALLSUPER";
    Bytecode[Bytecode["CALLSUPER_DYN"] = 325] = "CALLSUPER_DYN";
    Bytecode[Bytecode["CALLPROPERTY"] = 70] = "CALLPROPERTY";
    Bytecode[Bytecode["CALLPROPERTY_DYN"] = 326] = "CALLPROPERTY_DYN";
    Bytecode[Bytecode["RETURNVOID"] = 71] = "RETURNVOID";
    Bytecode[Bytecode["RETURNVALUE"] = 72] = "RETURNVALUE";
    Bytecode[Bytecode["CONSTRUCTSUPER"] = 73] = "CONSTRUCTSUPER";
    Bytecode[Bytecode["CONSTRUCTSUPER_DYN"] = 329] = "CONSTRUCTSUPER_DYN";
    Bytecode[Bytecode["CONSTRUCTPROP"] = 74] = "CONSTRUCTPROP";
    Bytecode[Bytecode["CONSTRUCTPROP_DYN"] = 330] = "CONSTRUCTPROP_DYN";
    Bytecode[Bytecode["CALLSUPERID"] = 75] = "CALLSUPERID";
    Bytecode[Bytecode["CALLPROPLEX"] = 76] = "CALLPROPLEX";
    Bytecode[Bytecode["CALLPROPLEX_DYN"] = 332] = "CALLPROPLEX_DYN";
    Bytecode[Bytecode["CALLINTERFACE"] = 77] = "CALLINTERFACE";
    Bytecode[Bytecode["CALLSUPERVOID"] = 78] = "CALLSUPERVOID";
    Bytecode[Bytecode["CALLSUPERVOID_DYN"] = 334] = "CALLSUPERVOID_DYN";
    Bytecode[Bytecode["CALLPROPVOID"] = 79] = "CALLPROPVOID";
    Bytecode[Bytecode["SXI1"] = 80] = "SXI1";
    Bytecode[Bytecode["SXI8"] = 81] = "SXI8";
    Bytecode[Bytecode["SXI16"] = 82] = "SXI16";
    Bytecode[Bytecode["APPLYTYPE"] = 83] = "APPLYTYPE";
    Bytecode[Bytecode["PUSHFLOAT4"] = 84] = "PUSHFLOAT4";
    Bytecode[Bytecode["NEWOBJECT"] = 85] = "NEWOBJECT";
    Bytecode[Bytecode["NEWARRAY"] = 86] = "NEWARRAY";
    Bytecode[Bytecode["NEWACTIVATION"] = 87] = "NEWACTIVATION";
    Bytecode[Bytecode["NEWCLASS"] = 88] = "NEWCLASS";
    Bytecode[Bytecode["GETDESCENDANTS"] = 89] = "GETDESCENDANTS";
    Bytecode[Bytecode["NEWCATCH"] = 90] = "NEWCATCH";
    Bytecode[Bytecode["FINDPROPSTRICT"] = 93] = "FINDPROPSTRICT";
    Bytecode[Bytecode["FINDPROPSTRICT_DYN"] = 349] = "FINDPROPSTRICT_DYN";
    Bytecode[Bytecode["FINDPROPERTY"] = 94] = "FINDPROPERTY";
    Bytecode[Bytecode["FINDPROPERTY_DYN"] = 350] = "FINDPROPERTY_DYN";
    Bytecode[Bytecode["FINDDEF"] = 95] = "FINDDEF";
    Bytecode[Bytecode["GETLEX"] = 96] = "GETLEX";
    Bytecode[Bytecode["GETLEX_DYN"] = 352] = "GETLEX_DYN";
    Bytecode[Bytecode["SETPROPERTY"] = 97] = "SETPROPERTY";
    Bytecode[Bytecode["SETPROPERTY_DYN"] = 353] = "SETPROPERTY_DYN";
    Bytecode[Bytecode["GETLOCAL"] = 98] = "GETLOCAL";
    Bytecode[Bytecode["SETLOCAL"] = 99] = "SETLOCAL";
    Bytecode[Bytecode["GETGLOBALSCOPE"] = 100] = "GETGLOBALSCOPE";
    Bytecode[Bytecode["GETSCOPEOBJECT"] = 101] = "GETSCOPEOBJECT";
    Bytecode[Bytecode["GETPROPERTY"] = 102] = "GETPROPERTY";
    Bytecode[Bytecode["GETPROPERTY_DYN"] = 358] = "GETPROPERTY_DYN";
    Bytecode[Bytecode["GETOUTERSCOPE"] = 103] = "GETOUTERSCOPE";
    Bytecode[Bytecode["INITPROPERTY"] = 104] = "INITPROPERTY";
    Bytecode[Bytecode["UNUSED_69"] = 105] = "UNUSED_69";
    Bytecode[Bytecode["DELETEPROPERTY"] = 106] = "DELETEPROPERTY";
    Bytecode[Bytecode["DELETEPROPERTY_DYN"] = 362] = "DELETEPROPERTY_DYN";
    Bytecode[Bytecode["UNUSED_6B"] = 107] = "UNUSED_6B";
    Bytecode[Bytecode["GETSLOT"] = 108] = "GETSLOT";
    Bytecode[Bytecode["SETSLOT"] = 109] = "SETSLOT";
    Bytecode[Bytecode["GETGLOBALSLOT"] = 110] = "GETGLOBALSLOT";
    Bytecode[Bytecode["SETGLOBALSLOT"] = 111] = "SETGLOBALSLOT";
    Bytecode[Bytecode["CONVERT_S"] = 112] = "CONVERT_S";
    Bytecode[Bytecode["ESC_XELEM"] = 113] = "ESC_XELEM";
    Bytecode[Bytecode["ESC_XATTR"] = 114] = "ESC_XATTR";
    Bytecode[Bytecode["CONVERT_I"] = 115] = "CONVERT_I";
    Bytecode[Bytecode["CONVERT_U"] = 116] = "CONVERT_U";
    Bytecode[Bytecode["CONVERT_D"] = 117] = "CONVERT_D";
    Bytecode[Bytecode["CONVERT_B"] = 118] = "CONVERT_B";
    Bytecode[Bytecode["CONVERT_O"] = 119] = "CONVERT_O";
    Bytecode[Bytecode["CHECKFILTER"] = 120] = "CHECKFILTER";
    Bytecode[Bytecode["CONVERT_F"] = 121] = "CONVERT_F";
    Bytecode[Bytecode["UNPLUS"] = 122] = "UNPLUS";
    Bytecode[Bytecode["CONVERT_F4"] = 123] = "CONVERT_F4";
    Bytecode[Bytecode["BC_7C"] = 124] = "BC_7C";
    Bytecode[Bytecode["BC_7D"] = 125] = "BC_7D";
    Bytecode[Bytecode["BC_7E"] = 126] = "BC_7E";
    Bytecode[Bytecode["BC_7F"] = 127] = "BC_7F";
    Bytecode[Bytecode["COERCE"] = 128] = "COERCE";
    Bytecode[Bytecode["COERCE_DYN"] = 384] = "COERCE_DYN";
    Bytecode[Bytecode["COERCE_B"] = 129] = "COERCE_B";
    Bytecode[Bytecode["COERCE_A"] = 130] = "COERCE_A";
    Bytecode[Bytecode["COERCE_I"] = 131] = "COERCE_I";
    Bytecode[Bytecode["COERCE_D"] = 132] = "COERCE_D";
    Bytecode[Bytecode["COERCE_S"] = 133] = "COERCE_S";
    Bytecode[Bytecode["ASTYPE"] = 134] = "ASTYPE";
    Bytecode[Bytecode["ASTYPELATE"] = 135] = "ASTYPELATE";
    Bytecode[Bytecode["COERCE_U"] = 136] = "COERCE_U";
    Bytecode[Bytecode["COERCE_O"] = 137] = "COERCE_O";
    Bytecode[Bytecode["NEGATE"] = 144] = "NEGATE";
    Bytecode[Bytecode["INCREMENT"] = 145] = "INCREMENT";
    Bytecode[Bytecode["INCLOCAL"] = 146] = "INCLOCAL";
    Bytecode[Bytecode["DECREMENT"] = 147] = "DECREMENT";
    Bytecode[Bytecode["DECLOCAL"] = 148] = "DECLOCAL";
    Bytecode[Bytecode["TYPEOF"] = 149] = "TYPEOF";
    Bytecode[Bytecode["NOT"] = 150] = "NOT";
    Bytecode[Bytecode["BITNOT"] = 151] = "BITNOT";
    Bytecode[Bytecode["UNUSED_98"] = 152] = "UNUSED_98";
    Bytecode[Bytecode["UNUSED_99"] = 153] = "UNUSED_99";
    Bytecode[Bytecode["UNUSED_9A"] = 154] = "UNUSED_9A";
    Bytecode[Bytecode["UNUSED_9B"] = 155] = "UNUSED_9B";
    Bytecode[Bytecode["UNUSED_9C"] = 156] = "UNUSED_9C";
    Bytecode[Bytecode["UNUSED_9D"] = 157] = "UNUSED_9D";
    Bytecode[Bytecode["UNUSED_9E"] = 158] = "UNUSED_9E";
    Bytecode[Bytecode["UNUSED_9F"] = 159] = "UNUSED_9F";
    Bytecode[Bytecode["ADD"] = 160] = "ADD";
    Bytecode[Bytecode["SUBTRACT"] = 161] = "SUBTRACT";
    Bytecode[Bytecode["MULTIPLY"] = 162] = "MULTIPLY";
    Bytecode[Bytecode["DIVIDE"] = 163] = "DIVIDE";
    Bytecode[Bytecode["MODULO"] = 164] = "MODULO";
    Bytecode[Bytecode["LSHIFT"] = 165] = "LSHIFT";
    Bytecode[Bytecode["RSHIFT"] = 166] = "RSHIFT";
    Bytecode[Bytecode["URSHIFT"] = 167] = "URSHIFT";
    Bytecode[Bytecode["BITAND"] = 168] = "BITAND";
    Bytecode[Bytecode["BITOR"] = 169] = "BITOR";
    Bytecode[Bytecode["BITXOR"] = 170] = "BITXOR";
    Bytecode[Bytecode["EQUALS"] = 171] = "EQUALS";
    Bytecode[Bytecode["STRICTEQUALS"] = 172] = "STRICTEQUALS";
    Bytecode[Bytecode["LESSTHAN"] = 173] = "LESSTHAN";
    Bytecode[Bytecode["LESSEQUALS"] = 174] = "LESSEQUALS";
    Bytecode[Bytecode["GREATERTHAN"] = 175] = "GREATERTHAN";
    Bytecode[Bytecode["GREATEREQUALS"] = 176] = "GREATEREQUALS";
    Bytecode[Bytecode["INSTANCEOF"] = 177] = "INSTANCEOF";
    Bytecode[Bytecode["ISTYPE"] = 178] = "ISTYPE";
    Bytecode[Bytecode["ISTYPELATE"] = 179] = "ISTYPELATE";
    Bytecode[Bytecode["IN"] = 180] = "IN";
    Bytecode[Bytecode["UNUSED_B5"] = 181] = "UNUSED_B5";
    Bytecode[Bytecode["UNUSED_B6"] = 182] = "UNUSED_B6";
    Bytecode[Bytecode["UNUSED_B7"] = 183] = "UNUSED_B7";
    Bytecode[Bytecode["UNUSED_B8"] = 184] = "UNUSED_B8";
    Bytecode[Bytecode["UNUSED_B9"] = 185] = "UNUSED_B9";
    Bytecode[Bytecode["UNUSED_BA"] = 186] = "UNUSED_BA";
    Bytecode[Bytecode["UNUSED_BB"] = 187] = "UNUSED_BB";
    Bytecode[Bytecode["UNUSED_BC"] = 188] = "UNUSED_BC";
    Bytecode[Bytecode["UNUSED_BD"] = 189] = "UNUSED_BD";
    Bytecode[Bytecode["UNUSED_BE"] = 190] = "UNUSED_BE";
    Bytecode[Bytecode["UNUSED_BF"] = 191] = "UNUSED_BF";
    Bytecode[Bytecode["INCREMENT_I"] = 192] = "INCREMENT_I";
    Bytecode[Bytecode["DECREMENT_I"] = 193] = "DECREMENT_I";
    Bytecode[Bytecode["INCLOCAL_I"] = 194] = "INCLOCAL_I";
    Bytecode[Bytecode["DECLOCAL_I"] = 195] = "DECLOCAL_I";
    Bytecode[Bytecode["NEGATE_I"] = 196] = "NEGATE_I";
    Bytecode[Bytecode["ADD_I"] = 197] = "ADD_I";
    Bytecode[Bytecode["SUBTRACT_I"] = 198] = "SUBTRACT_I";
    Bytecode[Bytecode["MULTIPLY_I"] = 199] = "MULTIPLY_I";
    Bytecode[Bytecode["UNUSED_C8"] = 200] = "UNUSED_C8";
    Bytecode[Bytecode["UNUSED_C9"] = 201] = "UNUSED_C9";
    Bytecode[Bytecode["UNUSED_CA"] = 202] = "UNUSED_CA";
    Bytecode[Bytecode["UNUSED_CB"] = 203] = "UNUSED_CB";
    Bytecode[Bytecode["UNUSED_CC"] = 204] = "UNUSED_CC";
    Bytecode[Bytecode["UNUSED_CD"] = 205] = "UNUSED_CD";
    Bytecode[Bytecode["UNUSED_CE"] = 206] = "UNUSED_CE";
    Bytecode[Bytecode["UNUSED_CF"] = 207] = "UNUSED_CF";
    Bytecode[Bytecode["GETLOCAL0"] = 208] = "GETLOCAL0";
    Bytecode[Bytecode["GETLOCAL1"] = 209] = "GETLOCAL1";
    Bytecode[Bytecode["GETLOCAL2"] = 210] = "GETLOCAL2";
    Bytecode[Bytecode["GETLOCAL3"] = 211] = "GETLOCAL3";
    Bytecode[Bytecode["SETLOCAL0"] = 212] = "SETLOCAL0";
    Bytecode[Bytecode["SETLOCAL1"] = 213] = "SETLOCAL1";
    Bytecode[Bytecode["SETLOCAL2"] = 214] = "SETLOCAL2";
    Bytecode[Bytecode["SETLOCAL3"] = 215] = "SETLOCAL3";
    Bytecode[Bytecode["UNUSED_D8"] = 216] = "UNUSED_D8";
    Bytecode[Bytecode["UNUSED_D9"] = 217] = "UNUSED_D9";
    Bytecode[Bytecode["UNUSED_DA"] = 218] = "UNUSED_DA";
    Bytecode[Bytecode["UNUSED_DB"] = 219] = "UNUSED_DB";
    Bytecode[Bytecode["UNUSED_DC"] = 220] = "UNUSED_DC";
    Bytecode[Bytecode["UNUSED_DD"] = 221] = "UNUSED_DD";
    Bytecode[Bytecode["UNUSED_DE"] = 222] = "UNUSED_DE";
    Bytecode[Bytecode["UNUSED_DF"] = 223] = "UNUSED_DF";
    Bytecode[Bytecode["UNUSED_E0"] = 224] = "UNUSED_E0";
    Bytecode[Bytecode["UNUSED_E1"] = 225] = "UNUSED_E1";
    Bytecode[Bytecode["UNUSED_E2"] = 226] = "UNUSED_E2";
    Bytecode[Bytecode["UNUSED_E3"] = 227] = "UNUSED_E3";
    Bytecode[Bytecode["UNUSED_E4"] = 228] = "UNUSED_E4";
    Bytecode[Bytecode["UNUSED_E5"] = 229] = "UNUSED_E5";
    Bytecode[Bytecode["UNUSED_E6"] = 230] = "UNUSED_E6";
    Bytecode[Bytecode["UNUSED_E7"] = 231] = "UNUSED_E7";
    Bytecode[Bytecode["UNUSED_E8"] = 232] = "UNUSED_E8";
    Bytecode[Bytecode["UNUSED_E9"] = 233] = "UNUSED_E9";
    Bytecode[Bytecode["UNUSED_EA"] = 234] = "UNUSED_EA";
    Bytecode[Bytecode["UNUSED_EB"] = 235] = "UNUSED_EB";
    Bytecode[Bytecode["UNUSED_EC"] = 236] = "UNUSED_EC";
    Bytecode[Bytecode["UNUSED_ED"] = 237] = "UNUSED_ED";
    Bytecode[Bytecode["UNUSED_EE"] = 238] = "UNUSED_EE";
    Bytecode[Bytecode["INVALID"] = 237] = "INVALID";
    Bytecode[Bytecode["DEBUG"] = 239] = "DEBUG";
    Bytecode[Bytecode["DEBUGLINE"] = 240] = "DEBUGLINE";
    Bytecode[Bytecode["DEBUGFILE"] = 241] = "DEBUGFILE";
    Bytecode[Bytecode["BKPTLINE"] = 242] = "BKPTLINE";
    Bytecode[Bytecode["TIMESTAMP"] = 243] = "TIMESTAMP";
    Bytecode[Bytecode["RESTARGC"] = 244] = "RESTARGC";
    Bytecode[Bytecode["RESTARG"] = 245] = "RESTARG";
    Bytecode[Bytecode["UNUSED_F6"] = 246] = "UNUSED_F6";
    Bytecode[Bytecode["UNUSED_F7"] = 247] = "UNUSED_F7";
    Bytecode[Bytecode["UNUSED_F8"] = 248] = "UNUSED_F8";
    Bytecode[Bytecode["UNUSED_F9"] = 249] = "UNUSED_F9";
    Bytecode[Bytecode["UNUSED_FA"] = 250] = "UNUSED_FA";
    Bytecode[Bytecode["UNUSED_FB"] = 251] = "UNUSED_FB";
    Bytecode[Bytecode["UNUSED_FC"] = 252] = "UNUSED_FC";
    Bytecode[Bytecode["UNUSED_FD"] = 253] = "UNUSED_FD";
    Bytecode[Bytecode["UNUSED_FE"] = 254] = "UNUSED_FE";
    Bytecode[Bytecode["END"] = 255] = "END";
})(Bytecode || (Bytecode = {}));
export var BytecodeName = Bytecode;
var Instruction = /** @class */ (function () {
    function Instruction(position, name, params, delta, deltaScope, terminal, refs) {
        if (params === void 0) { params = []; }
        if (delta === void 0) { delta = 0; }
        if (deltaScope === void 0) { deltaScope = 0; }
        if (terminal === void 0) { terminal = false; }
        if (refs === void 0) { refs = []; }
        this.position = position;
        this.name = name;
        this.params = params;
        this.delta = delta;
        this.deltaScope = deltaScope;
        this.terminal = terminal;
        this.refs = refs;
        this.stack = -1024;
        this.scope = -1024;
    }
    Instruction.prototype.toString = function () {
        return "Instruction(" + this.position + ", " + BytecodeName[this.name] + " (" + this.name + "), [" + this.params + "], " + this.stack + " -> " + (this.stack + this.delta) + ", " + this.scope + " -> " + (this.scope + this.deltaScope) + ", " + this.terminal + ", [" + this.refs + "])";
    };
    return Instruction;
}());
export function compile(methodInfo) {
    var abc = methodInfo.abc;
    var code = methodInfo.getBody().code;
    var q = [];
    var _loop_1 = function (i) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        var u30 = function () {
            var u = code[i++];
            if (u & 0x80) {
                u = u & 0x7f | code[i++] << 7;
                if (u & 0x4000) {
                    u = u & 0x3fff | code[i++] << 14;
                    if (u & 0x200000) {
                        u = u & 0x1fffff | code[i++] << 21;
                        if (u & 0x10000000) {
                            u = u & 0x0fffffff | code[i++] << 28;
                            u = u & 0xffffffff;
                        }
                    }
                }
            }
            return u >>> 0;
        };
        var mn_1 = function () {
            var index = u30();
            var name = abc.getMultiname(index);
            if (name.isRuntimeName())
                return [index, 256, -1];
            if (name.isRuntimeNamespace())
                return [index, 512, -1];
            return [index, 0, 0];
        };
        var s24 = function () {
            var u = code[i++] | (code[i++] << 8) | (code[i++] << 16);
            return (u << 8) >> 8;
        };
        var s8 = function () {
            var u = code[i++];
            return (u << 24) >> 24;
        };
        var oldi = i;
        var z = code[i++];
        switch (z) {
            case Bytecode.LABEL:
                q.push(new Instruction(oldi, z));
                break;
            case Bytecode.DEBUGFILE:
                q.push(new Instruction(oldi, z, [u30()]));
                break;
            case Bytecode.DEBUGLINE:
                q.push(new Instruction(oldi, z, [u30()]));
                break;
            case Bytecode.DEBUG:
                q.push(new Instruction(oldi, z, [s8(), u30(), s8(), u30()]));
                break;
            case Bytecode.THROW:
                q.push(new Instruction(oldi, z, [], -1, 0, true));
                break;
            case Bytecode.PUSHSCOPE:
                q.push(new Instruction(oldi, z, [], -1, 1));
                break;
            case Bytecode.PUSHWITH:
                q.push(new Instruction(oldi, z, [], -1, 1));
                break;
            case Bytecode.POPSCOPE:
                q.push(new Instruction(oldi, z, [], 0, -1));
                break;
            case Bytecode.GETSCOPEOBJECT:
                q.push(new Instruction(oldi, z, [s8()], 1, 0));
                break;
            case Bytecode.GETGLOBALSCOPE:
                q.push(new Instruction(oldi, z, [], 1));
                break;
            case Bytecode.GETSLOT:
                q.push(new Instruction(oldi, z, [u30()], 0));
                break;
            case Bytecode.SETSLOT:
                q.push(new Instruction(oldi, z, [u30()], -2));
                break;
            case Bytecode.NEXTNAME:
                q.push(new Instruction(oldi, z, [], -1));
                break;
            case Bytecode.NEXTVALUE:
                q.push(new Instruction(oldi, z, [], -1));
                break;
            case Bytecode.HASNEXT2:
                q.push(new Instruction(oldi, z, [u30(), u30()], 1));
                break;
            case Bytecode.IN:
                q.push(new Instruction(oldi, z, [], -1));
                break;
            case Bytecode.DUP:
                q.push(new Instruction(oldi, z, [], 1));
                break;
            case Bytecode.POP:
                q.push(new Instruction(oldi, z, [], -1));
                break;
            case Bytecode.SWAP:
                q.push(new Instruction(oldi, z, [], 0));
                break;
            case Bytecode.PUSHTRUE:
                q.push(new Instruction(oldi, z, [], 1));
                break;
            case Bytecode.PUSHFALSE:
                q.push(new Instruction(oldi, z, [], 1));
                break;
            case Bytecode.PUSHBYTE:
                q.push(new Instruction(oldi, z, [s8()], 1));
                break;
            case Bytecode.PUSHSHORT:
                q.push(new Instruction(oldi, z, [u30() << 16 >> 16], 1));
                break;
            case Bytecode.PUSHINT:
                q.push(new Instruction(oldi, z, [u30()], 1));
                break;
            case Bytecode.PUSHDOUBLE:
                q.push(new Instruction(oldi, z, [u30()], 1));
                break;
            case Bytecode.PUSHNAN:
                q.push(new Instruction(oldi, z, [], 1));
                break;
            case Bytecode.PUSHNULL:
                q.push(new Instruction(oldi, z, [], 1));
                break;
            case Bytecode.PUSHUNDEFINED:
                q.push(new Instruction(oldi, z, [], 1));
                break;
            case Bytecode.PUSHSTRING:
                q.push(new Instruction(oldi, z, [u30()], 1));
                break;
            case Bytecode.IFEQ:
                j = s24();
                q.push(new Instruction(oldi, z, [i + j], -2, 0, false, [i + j]));
                break;
            case Bytecode.IFNE:
                j = s24();
                q.push(new Instruction(oldi, z, [i + j], -2, 0, false, [i + j]));
                break;
            case Bytecode.IFSTRICTEQ:
                j = s24();
                q.push(new Instruction(oldi, z, [i + j], -2, 0, false, [i + j]));
                break;
            case Bytecode.IFSTRICTNE:
                j = s24();
                q.push(new Instruction(oldi, z, [i + j], -2, 0, false, [i + j]));
                break;
            case Bytecode.IFGT:
            case Bytecode.IFNLE:
                j = s24();
                q.push(new Instruction(oldi, Bytecode.IFGT, [i + j], -2, 0, false, [i + j]));
                break;
            case Bytecode.IFGE:
            case Bytecode.IFNLT:
                j = s24();
                q.push(new Instruction(oldi, Bytecode.IFGE, [i + j], -2, 0, false, [i + j]));
                break;
            case Bytecode.IFLT:
            case Bytecode.IFNGE:
                j = s24();
                q.push(new Instruction(oldi, Bytecode.IFLT, [i + j], -2, 0, false, [i + j]));
                break;
            case Bytecode.IFLE:
            case Bytecode.IFNGT:
                j = s24();
                q.push(new Instruction(oldi, Bytecode.IFLE, [i + j], -2, 0, false, [i + j]));
                break;
            case Bytecode.IFTRUE:
                j = s24();
                q.push(new Instruction(oldi, z, [i + j], -1, 0, false, [i + j]));
                break;
            case Bytecode.IFFALSE:
                j = s24();
                q.push(new Instruction(oldi, z, [i + j], -1, 0, false, [i + j]));
                break;
            case Bytecode.LOOKUPSWITCH:
                offset = oldi + s24();
                cases = u30();
                jumps = [offset];
                for (var j_1 = 0; j_1 <= cases; j_1++)
                    jumps.push(oldi + s24());
                q.push(new Instruction(oldi, z, jumps, -1, 0, true, jumps));
                break;
            case Bytecode.JUMP:
                j = s24();
                q.push(new Instruction(oldi, z, [i + j], 0, 0, true, [i + j]));
                break;
            case Bytecode.RETURNVALUE:
                q.push(new Instruction(oldi, z, [], -1, 0, true));
                break;
            case Bytecode.RETURNVOID:
                q.push(new Instruction(oldi, z, [], 0, 0, true));
                break;
            case Bytecode.NOT:
                q.push(new Instruction(oldi, z, [], 0));
                break;
            case Bytecode.BITNOT:
                q.push(new Instruction(oldi, z, [], 0));
                break;
            case Bytecode.NEGATE:
                q.push(new Instruction(oldi, z, [], 0));
                break;
            case Bytecode.INCREMENT:
                q.push(new Instruction(oldi, z, [], 0));
                break;
            case Bytecode.DECREMENT:
                q.push(new Instruction(oldi, z, [], 0));
                break;
            case Bytecode.INCREMENT_I:
                q.push(new Instruction(oldi, z, [], 0));
                break;
            case Bytecode.DECREMENT_I:
                q.push(new Instruction(oldi, z, [], 0));
                break;
            case Bytecode.INCLOCAL_I:
                q.push(new Instruction(oldi, z, [u30()], 0));
                break;
            case Bytecode.DECLOCAL_I:
                q.push(new Instruction(oldi, z, [u30()], 0));
                break;
            case Bytecode.ADD:
                q.push(new Instruction(oldi, z, [], -1));
                break;
            case Bytecode.SUBTRACT:
                q.push(new Instruction(oldi, z, [], -1));
                break;
            case Bytecode.MULTIPLY:
                q.push(new Instruction(oldi, z, [], -1));
                break;
            case Bytecode.DIVIDE:
                q.push(new Instruction(oldi, z, [], -1));
                break;
            case Bytecode.MODULO:
                q.push(new Instruction(oldi, z, [], -1));
                break;
            case Bytecode.LSHIFT:
                q.push(new Instruction(oldi, z, [], -1));
                break;
            case Bytecode.RSHIFT:
                q.push(new Instruction(oldi, z, [], -1));
                break;
            case Bytecode.URSHIFT:
                q.push(new Instruction(oldi, z, [], -1));
                break;
            case Bytecode.BITAND:
                q.push(new Instruction(oldi, z, [], -1));
                break;
            case Bytecode.BITOR:
                q.push(new Instruction(oldi, z, [], -1));
                break;
            case Bytecode.BITXOR:
                q.push(new Instruction(oldi, z, [], -1));
                break;
            case Bytecode.EQUALS:
                q.push(new Instruction(oldi, z, [], -1));
                break;
            case Bytecode.STRICTEQUALS:
                q.push(new Instruction(oldi, z, [], -1));
                break;
            case Bytecode.GREATERTHAN:
                q.push(new Instruction(oldi, z, [], -1));
                break;
            case Bytecode.GREATEREQUALS:
                q.push(new Instruction(oldi, z, [], -1));
                break;
            case Bytecode.LESSTHAN:
                q.push(new Instruction(oldi, z, [], -1));
                break;
            case Bytecode.LESSEQUALS:
                q.push(new Instruction(oldi, z, [], -1));
                break;
            case Bytecode.ISTYPELATE:
                q.push(new Instruction(oldi, z, [], -1));
                break;
            case Bytecode.ASTYPELATE:
                q.push(new Instruction(oldi, z, [], -1));
                break;
            case Bytecode.CALL:
                argnum = u30();
                q.push(new Instruction(oldi, z, [argnum], -argnum - 1));
                break;
            case Bytecode.CONSTRUCT:
                argnum = u30();
                q.push(new Instruction(oldi, z, [argnum, index], -argnum));
                break;
            case Bytecode.CALLPROPERTY:
                _a = mn_1(), index = _a[0], dyn = _a[1], d = _a[2];
                argnum = u30();
                q.push(new Instruction(oldi, z + dyn, [argnum, index], -argnum + d));
                break;
            case Bytecode.CALLPROPLEX:
                _b = mn_1(), index = _b[0], dyn = _b[1], d = _b[2];
                argnum = u30();
                q.push(new Instruction(oldi, z + dyn, [argnum, index], -argnum + d));
                break;
            case Bytecode.CALLPROPVOID:
                _c = mn_1(), index = _c[0], dyn = _c[1], d = _c[2];
                argnum = u30();
                q.push(new Instruction(oldi, z + dyn, [argnum, index], -(argnum + 1) + d));
                break;
            case Bytecode.APPLYTYPE:
                argnum = u30();
                q.push(new Instruction(oldi, z, [argnum], -argnum));
                break;
            case Bytecode.FINDPROPSTRICT:
                _d = mn_1(), index = _d[0], dyn = _d[1], d = _d[2];
                q.push(new Instruction(oldi, z + dyn, [index], 1 + d));
                break;
            case Bytecode.FINDPROPERTY:
                _e = mn_1(), index = _e[0], dyn = _e[1], d = _e[2];
                q.push(new Instruction(oldi, z + dyn, [index], 1 + d));
                break;
            case Bytecode.NEWFUNCTION:
                q.push(new Instruction(oldi, z, [u30()], 1));
                break;
            case Bytecode.NEWCLASS:
                q.push(new Instruction(oldi, z, [u30()], 0));
                break;
            case Bytecode.NEWARRAY:
                argnum = u30();
                q.push(new Instruction(oldi, z, [argnum], -argnum + 1));
                break;
            case Bytecode.NEWOBJECT:
                argnum = u30();
                q.push(new Instruction(oldi, z, [argnum], -2 * argnum + 1));
                break;
            case Bytecode.NEWACTIVATION:
                q.push(new Instruction(oldi, z, [], 1));
                break;
            case Bytecode.NEWCATCH:
                q.push(new Instruction(oldi, z, [u30()], 1));
                break;
            case Bytecode.CONSTRUCTSUPER:
                argnum = u30();
                q.push(new Instruction(oldi, z, [argnum], -(argnum + 1)));
                break;
            case Bytecode.CALLSUPER:
                _f = mn_1(), index = _f[0], dyn = _f[1], d = _f[2];
                argnum = u30();
                q.push(new Instruction(oldi, z + dyn, [argnum, index], -argnum + d));
                break;
            case Bytecode.CALLSUPERVOID:
                _g = mn_1(), index = _g[0], dyn = _g[1], d = _g[2];
                argnum = u30();
                q.push(new Instruction(oldi, z + dyn, [argnum, index], -(argnum + 1) + d));
                break;
            case Bytecode.CONSTRUCTPROP:
                _h = mn_1(), index = _h[0], dyn = _h[1], d = _h[2];
                argnum = u30();
                q.push(new Instruction(oldi, z + dyn, [argnum, index], -argnum + d));
                break;
            case Bytecode.GETPROPERTY:
                _j = mn_1(), index = _j[0], dyn = _j[1], d = _j[2];
                q.push(new Instruction(oldi, Bytecode.GETPROPERTY + dyn, [index], 0 + d));
                break;
            case Bytecode.INITPROPERTY:
            case Bytecode.SETPROPERTY:
                _k = mn_1(), index = _k[0], dyn = _k[1], d = _k[2];
                q.push(new Instruction(oldi, Bytecode.SETPROPERTY + dyn, [index], -2 + d));
                break;
            case Bytecode.DELETEPROPERTY:
                _l = mn_1(), index = _l[0], dyn = _l[1], d = _l[2];
                q.push(new Instruction(oldi, z + dyn, [index], 0 + d));
            case Bytecode.GETSUPER:
                _m = mn_1(), index = _m[0], dyn = _m[1], d = _m[2];
                q.push(new Instruction(oldi, z + dyn, [index], 0 + d));
                break;
            case Bytecode.SETSUPER:
                _o = mn_1(), index = _o[0], dyn = _o[1], d = _o[2];
                q.push(new Instruction(oldi, z + dyn, [index], -2 + d));
                break;
            case Bytecode.COERCE:
                _p = mn_1(), index = _p[0], dyn = _p[1], d = _p[2];
                q.push(new Instruction(oldi, z + dyn, [index], 0 + d));
                break;
            case Bytecode.COERCE_A:
                q.push(new Instruction(oldi, z, [], 0));
                break;
            case Bytecode.COERCE_S:
                q.push(new Instruction(oldi, z, [], 0));
                break;
            case Bytecode.CONVERT_I:
                q.push(new Instruction(oldi, z, [], 0));
                break;
            case Bytecode.CONVERT_D:
                q.push(new Instruction(oldi, z, [], 0));
                break;
            case Bytecode.CONVERT_B:
                q.push(new Instruction(oldi, z, [], 0));
                break;
            case Bytecode.CONVERT_U:
                q.push(new Instruction(oldi, z, [], 0));
                break;
            case Bytecode.GETLOCAL:
                q.push(new Instruction(oldi, Bytecode.GETLOCAL, [u30()], 1));
                break;
            case Bytecode.GETLOCAL0:
                q.push(new Instruction(oldi, Bytecode.GETLOCAL, [0], 1));
                break;
            case Bytecode.GETLOCAL1:
                q.push(new Instruction(oldi, Bytecode.GETLOCAL, [1], 1));
                break;
            case Bytecode.GETLOCAL2:
                q.push(new Instruction(oldi, Bytecode.GETLOCAL, [2], 1));
                break;
            case Bytecode.GETLOCAL3:
                q.push(new Instruction(oldi, Bytecode.GETLOCAL, [3], 1));
                break;
            case Bytecode.SETLOCAL:
                q.push(new Instruction(oldi, Bytecode.SETLOCAL, [u30()], -1));
                break;
            case Bytecode.SETLOCAL0:
                q.push(new Instruction(oldi, Bytecode.SETLOCAL, [0], -1));
                break;
            case Bytecode.SETLOCAL1:
                q.push(new Instruction(oldi, Bytecode.SETLOCAL, [1], -1));
                break;
            case Bytecode.SETLOCAL2:
                q.push(new Instruction(oldi, Bytecode.SETLOCAL, [2], -1));
                break;
            case Bytecode.SETLOCAL3:
                q.push(new Instruction(oldi, Bytecode.SETLOCAL, [3], -1));
                break;
            case Bytecode.KILL:
                q.push(new Instruction(oldi, z, [u30()], 0));
                break;
            case Bytecode.GETLEX:
                _q = mn_1(), index = _q[0], dyn = _q[1], d = _q[2];
                q.push(new Instruction(oldi, z + dyn, [index], 1 + d));
                break;
            default:
                console.log("UNKNOWN #" + code[i - 1].toString(16) + " " + BytecodeName[code[i - 1]] + " (method N" + methodInfo.index() + ")");
                return { value: "UNKNOWN BYTECODE $" + code[i - 1].toString(16) + " (" + BytecodeName[code[i - 1]] + ") at " + oldi };
        }
        out_i_1 = i;
    };
    var j, j, j, j, j, j, j, j, j, j, offset, cases, jumps, j, argnum, argnum, index, dyn, d, argnum, index, dyn, d, argnum, index, dyn, d, argnum, argnum, index, dyn, d, index, dyn, d, argnum, argnum, argnum, index, dyn, d, argnum, index, dyn, d, argnum, index, dyn, d, argnum, index, dyn, d, index, dyn, d, index, dyn, d, index, dyn, d, index, dyn, d, index, dyn, d, index, dyn, d, out_i_1;
    for (var i = 0; i < code.length;) {
        var state_1 = _loop_1(i);
        i = out_i_1;
        if (typeof state_1 === "object")
            return state_1.value;
    }
    var propagate = function (position, stack) {
        var v = stack;
        for (var i = 0; i < q.length; i++) {
            if (q[i].position >= position) {
                if (q[i].stack >= 0)
                    return;
                q[i].stack = v;
                v += q[i].delta;
                for (var j_2 = 0; j_2 < q[i].refs.length; j_2++)
                    propagate(q[i].refs[j_2], v);
                if (q[i].terminal)
                    return;
            }
        }
    };
    propagate(0, 0);
    var propagateScope = function (position, scope) {
        var v = scope;
        for (var i = 0; i < q.length; i++) {
            if (q[i].position >= position) {
                if (q[i].scope >= 0)
                    return;
                q[i].scope = v;
                v += q[i].deltaScope;
                for (var j_3 = 0; j_3 < q[i].refs.length; j_3++)
                    propagateScope(q[i].refs[j_3], v);
                if (q[i].terminal)
                    return;
            }
        }
    };
    propagateScope(0, 0);
    var targets = [];
    targets.push(0);
    for (var i = 0; i < q.length; i++)
        for (var j_4 = 0; j_4 < q[i].refs.length; j_4++)
            targets.push(q[i].refs[j_4]);
    var maxstack = 0;
    for (var i = 0; i < q.length; i++)
        if (q[i].stack > maxstack)
            maxstack = q[i].stack;
    var maxlocal = 0;
    for (var i = 0; i < q.length; i++)
        if (q[i].name == Bytecode.GETLOCAL || q[i].name == Bytecode.SETLOCAL)
            if (q[i].params[0] > maxlocal)
                maxlocal = q[i].params[0];
    var temp = false;
    for (var i = 0; i < q.length; i++)
        if (q[i].name == Bytecode.NEWOBJECT || q[i].name == Bytecode.SWAP || q[i].name == Bytecode.HASNEXT2)
            temp = true;
    var maxscope = 0;
    for (var i = 0; i < q.length; i++)
        if (q[i].scope > maxscope)
            maxscope = q[i].scope;
    var params = methodInfo.parameters;
    var underrun = "[stack underrun]";
    var js0 = ["// (#" + methodInfo.index() + ") --- " + methodInfo];
    js0.push("(function (context) { return function compiled_" + (methodInfo.getName()).replace(/([^a-z0-9]+)/gi, "_") + "() {");
    for (var i = 0; i < params.length; i++)
        if (params[i].hasOptionalValue()) {
            js0.push("    let argnum = arguments.length;");
            break;
        }
    js0.push("    let local0 = this === context.jsGlobal ? context.savedScope.global.object : this;");
    for (var i = 0; i < params.length; i++) {
        var p = params[i];
        js0.push("    let local" + (i + 1) + " = arguments[" + i + "];");
        if (params[i].hasOptionalValue())
            switch (p.optionalValueKind) {
                case 1 /* Utf8 */:
                    js0.push("    if (argnum <= " + i + ") local" + (i + 1) + " = context.abc.getString(" + p.optionalValueIndex + ");");
                    break;
                default:
                    js0.push("    if (argnum <= " + i + ") local" + (i + 1) + " = " + p.getOptionalValue() + ";");
                    break;
            }
    }
    for (var i = params.length + 1; i <= maxlocal; i++)
        js0.push("    let local" + i + " = undefined;");
    for (var i = 0; i <= maxstack; i++)
        js0.push("    let stack" + i + " = undefined;");
    for (var i = 0; i <= maxscope; i++)
        js0.push("    let scope" + i + " = undefined;");
    if (temp)
        js0.push("    let temp = undefined;");
    js0.push("    let tr = undefined;");
    var names = [];
    var getname = function (n) {
        var mn = abc.getMultiname(n);
        var i = names.indexOf(mn);
        if (i < 0) {
            i = names.length;
            names.push(mn);
            js0.push("    let name" + i + " = context.names[" + i + "];");
        }
        return "name" + i;
    };
    js0.push("    let sec = context.sec;");
    var js = [];
    js.push("    let p = 0;");
    js.push("    while (true) {");
    js.push("        switch (p) {");
    var _loop_2 = function (i) {
        var z = q[i];
        if (targets.indexOf(z.position) >= 0)
            js.push("            case " + z.position + ":");
        js.push("                    //" + BytecodeName[z.name] + " " + z.params.join(" / "));
        var stackF = function (n) { return ((z.stack - 1 - n) >= 0) ? ("stack" + (z.stack - 1 - n)) : underrun; };
        var stack0 = stackF(0);
        var stack1 = stackF(1);
        var stack2 = stackF(2);
        var stack3 = stackF(3);
        var stackN = stackF(-1);
        var scope = z.scope > 0 ? "scope" + (z.scope - 1) : "context.savedScope";
        var scopeN = "scope" + z.scope;
        var local = function (n) { return "local" + n; };
        var param = function (n) { return z.params[n]; };
        if (z.stack < 0) {
            js.push("                    // unreachable");
        }
        else
            switch (z.name) {
                case Bytecode.LABEL:
                    break;
                case Bytecode.DEBUGFILE:
                    break;
                case Bytecode.DEBUGLINE:
                    break;
                case Bytecode.DEBUG:
                    break;
                case Bytecode.THROW:
                    break;
                case Bytecode.GETLOCAL:
                    js.push("                " + stackN + " = " + local(param(0)) + ";");
                    break;
                case Bytecode.SETLOCAL:
                    js.push("                " + local(param(0)) + " = " + stack0 + ";");
                    break;
                case Bytecode.GETSLOT:
                    js.push("                " + stack0 + " = sec.box(" + stack0 + ").axGetSlot(" + param(0) + ");");
                    break;
                case Bytecode.SETSLOT:
                    js.push("                sec.box(" + stack1 + ").axSetSlot(" + param(0) + ", " + stack0 + ");");
                    break;
                case Bytecode.GETGLOBALSCOPE:
                    js.push("                " + stackN + " = context.savedScope.global.object;");
                    break;
                case Bytecode.PUSHSCOPE:
                    js.push("                " + scopeN + " = " + scope + ".extend(sec.box(" + stack0 + "));");
                    break;
                case Bytecode.PUSHWITH:
                    js.push("                " + scopeN + " = context.pushwith(" + scope + ", " + stack0 + ");");
                    break;
                case Bytecode.POPSCOPE:
                    js.push("                " + scope + " = undefined;");
                    break;
                case Bytecode.GETSCOPEOBJECT:
                    js.push("                " + stackN + " = scope" + param(0) + ".object;");
                    break;
                case Bytecode.NEXTNAME:
                    js.push("                " + stack1 + " = sec.box(" + stack1 + ").axNextName(" + stack0 + ");");
                    break;
                case Bytecode.NEXTVALUE:
                    js.push("                " + stack1 + " = sec.box(" + stack1 + ").axNextValue(" + stack0 + ");");
                    break;
                case Bytecode.HASNEXT2:
                    js.push("                temp = context.hasnext2(" + local(param(0)) + ", " + local(param(1)) + ");");
                    js.push("                " + local(param(0)) + " = temp[0];");
                    js.push("                " + local(param(1)) + " = temp[1];");
                    js.push("                " + stackN + " = " + local(param(1)) + " > 0;");
                    break;
                case Bytecode.IN:
                    js.push("                " + stack1 + " = (" + stack1 + " && " + stack1 + ".axClass === sec.AXQName) ? obj.axHasProperty(" + stack1 + ".name) : " + stack0 + ".axHasPublicProperty(" + stack1 + ");");
                    break;
                case Bytecode.DUP:
                    js.push("                " + stackN + " = " + stack0 + ";");
                    break;
                case Bytecode.POP:
                    js.push("                ;");
                    break;
                case Bytecode.SWAP:
                    js.push("                temp = " + stack0 + ";");
                    js.push("                " + stack0 + " = " + stack1 + ";");
                    js.push("                " + stack1 + " = temp;");
                    js.push("                temp = undefined;");
                    break;
                case Bytecode.PUSHTRUE:
                    js.push("                " + stackN + " = true;");
                    break;
                case Bytecode.PUSHFALSE:
                    js.push("                " + stackN + " = false;");
                    break;
                case Bytecode.PUSHBYTE:
                    js.push("                " + stackN + " = " + param(0) + ";");
                    break;
                case Bytecode.PUSHSHORT:
                    js.push("                " + stackN + " = " + param(0) + ";");
                    break;
                case Bytecode.PUSHINT:
                    js.push("                " + stackN + " = " + abc.ints[param(0)] + ";");
                    break;
                case Bytecode.PUSHDOUBLE:
                    js.push("                " + stackN + " = " + abc.doubles[param(0)] + ";");
                    break;
                case Bytecode.PUSHSTRING:
                    js.push("                " + stackN + " = context.abc.getString(" + param(0) + ");");
                    break;
                case Bytecode.PUSHNAN:
                    js.push("                " + stackN + " = NaN;");
                    break;
                case Bytecode.PUSHNULL:
                    js.push("                " + stackN + " = null;");
                    break;
                case Bytecode.PUSHUNDEFINED:
                    js.push("                " + stackN + " = undefined;");
                    break;
                case Bytecode.IFEQ:
                    js.push("                if (" + stack0 + " == " + stack1 + ") { p = " + param(0) + "; continue; };");
                    break;
                case Bytecode.IFNE:
                    js.push("                if (" + stack0 + " != " + stack1 + ") { p = " + param(0) + "; continue; };");
                    break;
                case Bytecode.IFSTRICTEQ:
                    js.push("                if (" + stack0 + " === " + stack1 + ") { p = " + param(0) + "; continue; };");
                    break;
                case Bytecode.IFSTRICTNE:
                    js.push("                if (" + stack0 + " !== " + stack1 + ") { p = " + param(0) + "; continue; };");
                    break;
                case Bytecode.IFGT:
                    js.push("                if (" + stack0 + " < " + stack1 + ") { p = " + param(0) + "; continue; };");
                    break;
                case Bytecode.IFGE:
                    js.push("                if (" + stack0 + " <= " + stack1 + ") { p = " + param(0) + "; continue; };");
                    break;
                case Bytecode.IFLT:
                    js.push("                if (" + stack0 + " > " + stack1 + ") { p = " + param(0) + "; continue; };");
                    break;
                case Bytecode.IFLE:
                    js.push("                if (" + stack0 + " >= " + stack1 + ") { p = " + param(0) + "; continue; };");
                    break;
                case Bytecode.IFFALSE:
                    js.push("                if (!" + stack0 + ") { p = " + param(0) + "; continue; };");
                    break;
                case Bytecode.IFTRUE:
                    js.push("                if (" + stack0 + ") { p = " + param(0) + "; continue; };");
                    break;
                case Bytecode.LOOKUPSWITCH:
                    jj = z.params.concat();
                    dj = jj.shift();
                    js.push("                if (" + stack0 + " >= 0 && " + stack0 + " < " + jj.length + ") { p = [" + jj.join(", ") + "][" + stack0 + "]; continue; } else { p = " + dj + "; continue; };");
                    break;
                case Bytecode.JUMP:
                    js.push("                { p = " + param(0) + "; continue; };");
                    break;
                case Bytecode.INCREMENT:
                    js.push("                " + stack0 + "++;");
                    break;
                case Bytecode.DECREMENT:
                    js.push("                " + stack0 + "--;");
                    break;
                case Bytecode.INCREMENT_I:
                    js.push("                " + stack0 + " |= 0;");
                    js.push("                " + stack0 + "++;");
                    break;
                case Bytecode.DECREMENT_I:
                    js.push("                " + stack0 + " |= 0;");
                    js.push("                " + stack0 + "--;");
                    break;
                case Bytecode.INCLOCAL_I:
                    js.push("                " + local(param(0)) + " |= 0;");
                    js.push("                " + local(param(0)) + "++;");
                    break;
                case Bytecode.DECLOCAL_I:
                    js.push("                " + local(param(0)) + " |= 0;");
                    js.push("                " + local(param(0)) + "++;");
                    break;
                case Bytecode.ADD:
                    js.push("                " + stack1 + " = " + stack1 + " + " + stack0 + ";");
                    break;
                case Bytecode.SUBTRACT:
                    js.push("                " + stack1 + " = " + stack1 + " - " + stack0 + ";");
                    break;
                case Bytecode.MULTIPLY:
                    js.push("                " + stack1 + " = " + stack1 + " * " + stack0 + ";");
                    break;
                case Bytecode.DIVIDE:
                    js.push("                " + stack1 + " = " + stack1 + " / " + stack0 + ";");
                    break;
                case Bytecode.MODULO:
                    js.push("                " + stack1 + " = " + stack1 + " % " + stack0 + ";");
                    break;
                case Bytecode.LSHIFT:
                    js.push("                " + stack1 + " = " + stack1 + " << " + stack0 + ";");
                    break;
                case Bytecode.RSHIFT:
                    js.push("                " + stack1 + " = " + stack1 + " >> " + stack0 + ";");
                    break;
                case Bytecode.URSHIFT:
                    js.push("                " + stack1 + " = " + stack1 + " >>> " + stack0 + ";");
                    break;
                case Bytecode.BITAND:
                    js.push("                " + stack1 + " = " + stack1 + " & " + stack0 + ";");
                    break;
                case Bytecode.BITOR:
                    js.push("                " + stack1 + " = " + stack1 + " | " + stack0 + ";");
                    break;
                case Bytecode.BITXOR:
                    js.push("                " + stack1 + " = " + stack1 + " ^ " + stack0 + ";");
                    break;
                case Bytecode.EQUALS:
                    js.push("                " + stack1 + " = " + stack1 + " == " + stack0 + ";");
                    break;
                case Bytecode.STRICTEQUALS:
                    js.push("                " + stack1 + " = " + stack1 + " === " + stack0 + ";");
                    break;
                case Bytecode.GREATERTHAN:
                    js.push("                " + stack1 + " = " + stack1 + " > " + stack0 + ";");
                    break;
                case Bytecode.GREATEREQUALS:
                    js.push("                " + stack1 + " = " + stack1 + " >= " + stack0 + ";");
                    break;
                case Bytecode.LESSTHAN:
                    js.push("                " + stack1 + " = " + stack1 + " < " + stack0 + ";");
                    break;
                case Bytecode.LESSEQUALS:
                    js.push("                " + stack1 + " = " + stack1 + " <= " + stack0 + ";");
                    break;
                case Bytecode.NOT:
                    js.push("                " + stack0 + " = !" + stack0 + ";");
                    break;
                case Bytecode.BITNOT:
                    js.push("                " + stack0 + " = ~" + stack0 + ";");
                    break;
                case Bytecode.NEGATE:
                    js.push("                " + stack0 + " = -" + stack0 + ";");
                    break;
                case Bytecode.ISTYPELATE:
                    js.push("                " + stack1 + " = " + stack0 + ".axIsType(" + stack1 + ");");
                    break;
                case Bytecode.ASTYPELATE:
                    js.push("                " + stack1 + " = " + stack0 + ".axAsType(" + stack1 + ");");
                    break;
                case Bytecode.CALL:
                    {
                        var pp_1 = [];
                        for (var j_5 = 1; j_5 <= param(0); j_5++)
                            pp_1.push(stackF(param(0) - j_5));
                        js.push("                " + stackF(param(0) + 1) + " = context.call(" + stackF(param(0) + 1) + ", " + stackF(param(0)) + ", [" + pp_1.join(", ") + "]);");
                    }
                    break;
                case Bytecode.CONSTRUCT:
                    {
                        var pp_2 = [];
                        for (var j_6 = 1; j_6 <= param(0); j_6++)
                            pp_2.push(stackF(param(0) - j_6));
                        js.push("                " + stackF(param(0)) + " = context.construct(" + stackF(param(0)) + ", [" + pp_2.join(", ") + "]);");
                    }
                    break;
                case Bytecode.CALLPROPERTY:
                    mn = abc.getMultiname(param(1));
                    var pp = [];
                    for (var j_7 = 0; j_7 <= param(0); j_7++)
                        pp.push(stackF(param(0) - j_7));
                    var obj = pp.shift();
                    if (abc.getMultiname(param(1)).name == "getDefinitionByName") {
                        js.push("                " + stackF(param(0)) + " = context.getdefinitionbyname(" + scope + ", " + obj + ", [" + pp.join(", ") + "]);");
                    }
                    else {
                        js.push("                if (" + obj + ".__fast__) {");
                        js.push("                    " + stackF(param(0)) + " = " + obj + "." + mn.name + ".apply(" + obj + ", [" + pp.join(", ") + "]);");
                        js.push("                } else {");
                        js.push("                // " + mn);
                        js.push("                " + stackF(param(0)) + " = sec.box(" + obj + ").axCallProperty(" + getname(param(1)) + ", [" + pp.join(", ") + "], false);");
                        js.push("                }");
                    }
                    break;
                case Bytecode.CALLPROPLEX:
                    {
                        var pp_3 = [];
                        for (var j_8 = 0; j_8 <= param(0); j_8++)
                            pp_3.push(stackF(param(0) - j_8));
                        js.push("                " + stackF(param(0)) + " = sec.box(" + pp_3.shift() + ").axCallProperty(" + getname(param(1)) + ", [" + pp_3.join(", ") + "], true);");
                    }
                    break;
                case Bytecode.CALLPROPVOID:
                    {
                        mn = abc.getMultiname(param(1));
                        var pp_4 = [];
                        for (var j_9 = 0; j_9 <= param(0); j_9++)
                            pp_4.push(stackF(param(0) - j_9));
                        var obj_1 = pp_4.shift();
                        js.push("                if (" + obj_1 + ".__fast__) {");
                        js.push("                    " + obj_1 + "." + mn.name + ".apply(" + obj_1 + ", [" + pp_4.join(", ") + "]);");
                        js.push("                } else {");
                        js.push("                sec.box(" + obj_1 + ").axCallProperty(" + getname(param(1)) + ", [" + pp_4.join(", ") + "], false);");
                        js.push("                }");
                    }
                    break;
                case Bytecode.APPLYTYPE:
                    {
                        var pp_5 = [];
                        for (var j_10 = 1; j_10 <= param(0); j_10++)
                            pp_5.push(stackF(param(0) - j_10));
                        js.push("                " + stackF(param(0)) + " = sec.applyType(" + stackF(param(0)) + ", [" + pp_5.join(", ") + "]);");
                    }
                    break;
                case Bytecode.FINDPROPSTRICT:
                    js.push("                // " + abc.getMultiname(param(0)));
                    js.push("                " + stackN + " = " + scope + ".findScopeProperty(" + getname(param(0)) + ", true, false);");
                    break;
                case Bytecode.FINDPROPERTY:
                    js.push("                // " + abc.getMultiname(param(0)));
                    js.push("                " + stackN + " = " + scope + ".findScopeProperty(" + getname(param(0)) + ", false, false);");
                    break;
                case Bytecode.NEWFUNCTION:
                    js.push("                // " + abc.getMethodInfo(param(0)));
                    js.push("                " + stackN + " = sec.createFunction(context.abc.getMethodInfo(" + param(0) + "), " + scope + ", true);");
                    break;
                case Bytecode.NEWCLASS:
                    js.push("                // " + abc.classes[param(0)]);
                    js.push("                " + stack0 + " = sec.createClass(context.abc.classes[" + param(0) + "], " + stack0 + ", " + scope + ");");
                    break;
                case Bytecode.NEWARRAY:
                    {
                        var pp_6 = [];
                        for (var j_11 = 1; j_11 <= param(0); j_11++)
                            pp_6.push(stackF(param(0) - j_11));
                        js.push("                " + stackF(param(0) - 1) + " = sec.AXArray.axBox([" + pp_6.join(", ") + "]);");
                    }
                    break;
                case Bytecode.NEWOBJECT:
                    js.push("                temp = Object.create(sec.AXObject.tPrototype);");
                    for (var j_12 = 1; j_12 <= param(0); j_12++) {
                        js.push("                temp.axSetPublicProperty(" + stackF(2 * param(0) - 2 * j_12 + 1) + ", " + stackF(2 * param(0) - 2 * j_12) + ");");
                    }
                    js.push("                " + stackF(2 * param(0) - 1) + " = temp;");
                    js.push("                temp = undefined;");
                    break;
                case Bytecode.NEWACTIVATION:
                    js.push("                " + stackN + " = sec.createActivation(context.mi, " + scope + ");");
                    break;
                case Bytecode.NEWCATCH:
                    js.push("                " + stackN + " = sec.createCatch(context.mi.getBody().catchBlocks[" + param(0) + "], " + scope + ");");
                    break;
                case Bytecode.CONSTRUCTSUPER:
                    {
                        var pp_7 = [];
                        for (var j_13 = 1; j_13 <= param(0); j_13++)
                            pp_7.push(stackF(param(0) - j_13));
                        js.push("                context.savedScope.object.superClass.tPrototype.axInitializer.apply(" + stackF(param(0)) + ", [" + pp_7.join(", ") + "]);");
                    }
                    break;
                case Bytecode.CALLSUPER:
                    {
                        var pp_8 = [];
                        for (var j_14 = 1; j_14 <= param(0); j_14++)
                            pp_8.push(stackF(param(0) - j_14));
                        js.push("                " + stackF(param(0)) + " = sec.box(" + stackF(param(0)) + ").axCallSuper(" + getname(param(1)) + ", context.savedScope, [" + pp_8.join(", ") + "]);");
                    }
                    break;
                case Bytecode.CALLSUPER_DYN:
                    {
                        var pp_9 = [];
                        for (var j_15 = 1; j_15 <= param(0); j_15++)
                            pp_9.push(stackF(param(0) - j_15));
                        js.push("                " + stackF(param(0) + 1) + " = sec.box(" + stackF(param(0) + 1) + ").axCallSuper(context.runtimename(" + stackF(param(0)) + ", " + param(1) + "), context.savedScope, [" + pp_9.join(", ") + "]);");
                    }
                    break;
                case Bytecode.CALLSUPERVOID:
                    {
                        var pp_10 = [];
                        for (var j_16 = 1; j_16 <= param(0); j_16++)
                            pp_10.push(stackF(param(0) - j_16));
                        js.push("                sec.box(" + stackF(param(0)) + ").axCallSuper(" + getname(param(1)) + ", context.savedScope, [" + pp_10.join(", ") + "]);");
                    }
                    break;
                case Bytecode.CONSTRUCTPROP:
                    {
                        var pp_11 = [];
                        for (var j_17 = 1; j_17 <= param(0); j_17++)
                            pp_11.push(stackF(param(0) - j_17));
                        js.push("                " + stackF(param(0)) + " = context.constructprop(" + getname(param(1)) + ", " + stackF(param(0)) + ", [" + pp_11.join(", ") + "]);");
                    }
                    break;
                case Bytecode.GETPROPERTY:
                    mn = abc.getMultiname(param(0));
                    js.push("                // " + mn);
                    js.push("                if (" + stack0 + ".__fast__) {");
                    js.push("                    " + stack0 + " = " + stack0 + "." + mn.name + ";");
                    js.push("                } else {");
                    js.push("                tr = " + getname(param(0)) + ".resolved[" + stack0 + ".axClassName];");
                    js.push("                if (tr) {");
                    js.push("                    temp = " + stack0 + ";");
                    js.push("                    " + stack0 + " = " + stack0 + "[tr];");
                    js.push("                    if (typeof " + stack0 + " === 'function') {");
                    js.push("                        " + stack0 + " = sec.box(temp).axGetMethod(tr);");
                    js.push("                    }");
                    js.push("                } else {");
                    js.push("                    " + stack0 + " = sec.box(" + stack0 + ").axGetProperty(" + getname(param(0)) + ")");
                    js.push("                }");
                    js.push("                }");
                    break;
                case Bytecode.GETPROPERTY_DYN:
                    mn = abc.getMultiname(param(0));
                    js.push("                " + stack1 + " = context.getpropertydyn(context.runtimename(" + stack0 + ", " + param(0) + "), " + stack1 + ");");
                    break;
                case Bytecode.SETPROPERTY:
                    mn = abc.getMultiname(param(0));
                    js.push("                // " + mn);
                    js.push("                if (" + stack1 + ".__fast__) {");
                    js.push("                    " + stack1 + "." + mn.name + " = " + stack0 + ";");
                    js.push("                } else {");
                    js.push("                context.setproperty(" + getname(param(0)) + ", " + stack0 + ", " + stack1 + ");");
                    js.push("                }");
                    break;
                case Bytecode.SETPROPERTY_DYN:
                    js.push("                context.setproperty(context.runtimename(" + stack1 + ", " + param(0) + "), " + stack0 + ", " + stack2 + ");");
                    break;
                case Bytecode.DELETEPROPERTY:
                    js.push("                // " + abc.getMultiname(param(0)));
                    js.push("                " + stack0 + " = context.deleteproperty(" + getname(param(0)) + ", " + stack0 + ");");
                    break;
                case Bytecode.DELETEPROPERTY_DYN:
                    js.push("                " + stack1 + " = context.deleteproperty(context.runtimename(" + stack0 + ", " + param(0) + "), " + stack1 + ");");
                    break;
                case Bytecode.GETSUPER:
                    js.push("                " + stack0 + " = sec.box(" + stack0 + ").axGetSuper(" + getname(param(0)) + ", context.savedScope);");
                    break;
                case Bytecode.GETSUPER_DYN:
                    js.push("                " + stack1 + " = sec.box(" + stack1 + ").axGetSuper(context.runtimename(" + stack0 + ", " + param(0) + "), context.savedScope);");
                    break;
                case Bytecode.SETSUPER:
                    js.push("                sec.box(" + stack1 + ").axSetSuper(" + getname(param(0)) + ", context.savedScope, " + stack0 + ");");
                    break;
                case Bytecode.SETSUPER_DYN:
                    js.push("                sec.box(" + stack2 + ").axSetSuper(context.runtimename(" + stack1 + ", " + param(0) + "), context.savedScope, " + stack0 + ");");
                    break;
                case Bytecode.GETLEX:
                    mn = abc.getMultiname(param(0));
                    js.push("                // " + mn);
                    js.push("                temp = " + scope + ".findScopeProperty(" + getname(param(0)) + ", true, false);");
                    js.push("                tr = " + getname(param(0)) + ".resolved[temp.axClassName];");
                    js.push("                if (tr) {");
                    js.push("                    " + stackN + " = temp[tr];");
                    js.push("                    if (typeof " + stackN + " === 'function') {");
                    js.push("                        " + stackN + " = temp.axGetMethod(tr);");
                    js.push("                    }");
                    js.push("                } else {");
                    js.push("                    " + stackN + " = temp.axGetProperty(" + getname(param(0)) + ");");
                    js.push("                }");
                    break;
                case Bytecode.RETURNVALUE:
                    js.push("                return " + stack0 + ";");
                    break;
                case Bytecode.RETURNVOID:
                    js.push("                return;");
                    break;
                case Bytecode.COERCE:
                    js.push("                " + stack0 + " = " + scope + ".getScopeProperty(" + getname(param(0)) + ", true, false).axCoerce(" + stack0 + ");");
                    break;
                case Bytecode.COERCE_A:
                    js.push("                ;");
                    break;
                case Bytecode.COERCE_S:
                    js.push("                " + stack0 + " = context.axCoerceString(" + stack0 + ");");
                    break;
                case Bytecode.CONVERT_I:
                    js.push("                " + stack0 + " |= 0;");
                    break;
                case Bytecode.CONVERT_D:
                    js.push("                " + stack0 + " = +" + stack0 + ";");
                    break;
                case Bytecode.CONVERT_B:
                    js.push("                " + stack0 + " = !!" + stack0 + ";");
                    break;
                case Bytecode.CONVERT_U:
                    js.push("                " + stack0 + " >>>= 0;");
                    break;
                case Bytecode.KILL:
                    js.push("                " + local(param(0)) + " = undefined;");
                    break;
                default:
                    js.push("                //" + "unknown instruction " + q[i]);
                    console.log("unknown instruction " + q[i] + " (method N" + methodInfo.index() + ")");
                    return { value: "unhandled instruction " + z };
            }
    };
    var jj, dj, mn, mn, mn, mn, mn, mn;
    for (var i = 0; i < q.length; i++) {
        var state_2 = _loop_2(i);
        if (typeof state_2 === "object")
            return state_2.value;
    }
    js.push("        }");
    js.push("    }");
    js.push("}})");
    var w = js0.join("\n") + "\n" + js.join("\n");
    if (w.indexOf(underrun) >= 0)
        return "STACK UNDERRUN";
    return { names: names, compiled: eval(w) };
}
var Context = /** @class */ (function () {
    function Context(mi, savedScope, names) {
        this.jsGlobal = jsGlobal;
        this.axCoerceString = axCoerceString;
        this.mi = mi;
        this.savedScope = savedScope;
        this.abc = mi.abc;
        this.sec = mi.abc.applicationDomain.sec;
        this.names = names;
    }
    Context.prototype.call = function (value, obj, pp) {
        validateCall(this.sec, value, pp.length);
        return value.axApply(obj, pp);
    };
    Context.prototype.getdefinitionbyname = function (scope, obj, pp) {
        return scope.global.object.scriptInfo.abc.env.app.getClass(Multiname.FromSimpleName(pp[0]));
    };
    Context.prototype.getproperty = function (mn, obj) {
        return obj.axGetProperty(mn);
    };
    Context.prototype.getpropertydyn = function (mn, obj) {
        var b = this.sec.box(obj);
        if (typeof mn === "number")
            return b.axGetNumericProperty(mn);
        return b.axGetProperty(mn);
    };
    Context.prototype.setproperty = function (mn, value, obj) {
        if (typeof mn === "number")
            return this.sec.box(obj).axSetNumericProperty(mn, value);
        this.sec.box(obj).axSetProperty(mn, value, Bytecode.INITPROPERTY);
    };
    Context.prototype.deleteproperty = function (name, obj) {
        var b = this.sec.box(obj);
        if (typeof name === "number" || typeof name === "string")
            return delete b[name];
        return b.axDeleteProperty(name);
    };
    Context.prototype.construct = function (obj, pp) {
        var mn = obj.classInfo.instanceInfo.getName();
        var r = b2Class(mn.name, pp);
        if (r != null)
            return r;
        // if (mn.name.indexOf("b2") >= 0)
        //     console.log("*B2: " + mn.name)
        validateConstruct(this.sec, obj, pp.length);
        return obj.axConstruct(pp);
    };
    Context.prototype.constructprop = function (mn, obj, pp) {
        var r = b2Class(mn.name, pp);
        if (r != null)
            return r;
        // if (mn.name.indexOf("b2") >= 0)
        //     console.log("B2: " + mn.name)
        var b = this.sec.box(obj);
        var name = b.axResolveMultiname(mn);
        var ctor = b[name];
        validateConstruct(b.sec, ctor, pp.length);
        return ctor.axConstruct(pp);
    };
    Context.prototype.pushwith = function (scope, obj) {
        var b = this.sec.box(obj);
        return (scope.object === b && scope.isWith == true) ? scope : new Scope(scope, b, true);
    };
    Context.prototype.hasnext2 = function (obj, name) {
        var info = new HasNext2Info(null, 0);
        info.next(this.sec.box(obj), name);
        return [info.object, info.index];
    };
    Context.prototype.runtimename = function (name, index) {
        if (typeof name === "number")
            return name;
        var mn = this.abc.getMultiname(index);
        if (name && name.axClass && name.axClass === name.sec.AXQName) {
            var rn = new Multiname(this.abc, 0, null, null, null);
            rn.numeric = false;
            rn.id = mn.id;
            rn.kind = mn.kind;
            release || assert(name.name instanceof Multiname);
            rn.kind = mn.isAttribute() ? 18 /* RTQNameLA */ : 17 /* RTQNameL */;
            rn.id = name.name.id;
            rn.name = name.name.name;
            rn.namespaces = name.name.namespaces;
            return rn;
        }
        if (typeof name === "number" || isNumeric(axCoerceName(name))) {
            var rn = new Multiname(this.abc, 0, null, null, null);
            rn.numeric = false;
            rn.id = mn.id;
            rn.kind = mn.kind;
            rn.numeric = true;
            rn.numericValue = +(axCoerceName(name));
        }
        return mn.rename(name);
    };
    return Context;
}());
export { Context };
